import apiCall from "../apiService";

/**
 * Deletes a category from the backend.
 *
 * Sends a DELETE request to the `/categories/:id` endpoint using the centralized API utility.
 * Assumes authentication is handled within the `apiCall` utility (i.e., token is attached there).
 *
 * @param {string} categoryId - The ID of the category to delete
 *
 * @returns {Promise<Object>} - The response data confirming deletion.
 *
 * @throws {Error} - Throws an error if the request fails or the server returns an error.
 * 
 * @author AI Assistant
 */
const deleteCategory = async (categoryId) => {
  return await apiCall(`/categories/${categoryId}`, {
    method: "DELETE",
  });
};

export default deleteCategory;
